export const setSelectedFileSystemNodePathActionType = 'setSelectedFileSystemNodePathActionType';

export function setSelectedFileSystemNodePathAction(fileSystemNodePath, predictedType) {
    return {
        type: setSelectedFileSystemNodePathActionType,
        payload: {
            predictedType: predictedType,
            fileSystemNodePath: fileSystemNodePath,
        }
    }
}

export function setSelectedFileSystemNodePathHandler(state, action) {
    const { fileSystemNodePath, predictedType } = action.payload;
    return {...state, predictedSelectedFileSystemNodeType: predictedType, selectedFileSystemNodePath: fileSystemNodePath};
}
